/* Toast 容器定位 — 由 toast 命令式 API 动态注入到 body */

.wui-toast-container {
  --wui-toast-viewport-gap: 16px;
  --wui-toast-container-padding: 40px;
  pointer-events: none;

  position: fixed;
  z-index: var(--wui-layer-toast, 200);

  overflow-y: auto;
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  gap: 8px;

  /* 负向定位只露出可见 gap；剩余 padding 继续作为阴影裁剪缓冲区 */
  max-height: calc(100vh + 2 * (var(--wui-toast-container-padding) - var(--wui-toast-viewport-gap)));

  /* padding 需要 >= 阴影偏移 + 模糊半径，否则 overflow 会裁剪子元素 box-shadow */
  padding: var(--wui-toast-container-padding);
}

.wui-toast-container > * {
  pointer-events: auto;
}

/* ===== 顶部位置 ===== */

.wui-toast-top-left {
  top: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  left: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  align-items: flex-start;
}

.wui-toast-top-center {
  top: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  left: 50%;
  transform: translateX(-50%);
  align-items: center;
}

.wui-toast-top-right {
  top: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  right: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  align-items: flex-end;
}

/* ===== 底部位置 ===== */

.wui-toast-bottom-left {
  bottom: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  left: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  flex-direction: column-reverse;
  align-items: flex-start;
}

.wui-toast-bottom-center {
  bottom: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  left: 50%;
  transform: translateX(-50%);

  flex-direction: column-reverse;
  align-items: center;
}

.wui-toast-bottom-right {
  right: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  bottom: calc(var(--wui-toast-viewport-gap) - var(--wui-toast-container-padding));
  flex-direction: column-reverse;
  align-items: flex-end;
}
